<div class="chat-window-container flex flex-column relative" *ngIf="activeConv$ | async as conv; else emptyState">
   <ng-container *ngIf="userPresence$ | async as presenceMap">
   <!-- Header -->
   <div class="header flex align-items-center justify-content-between z-2 py-2 px-3">
       <div class="flex align-items-center">
           <!-- Back Button (Mobile Only) -->
           <button pButton icon="pi pi-arrow-left" class="p-button-rounded p-button-text p-button-secondary mr-2 md:hidden" 
                   (click)="goBack()"></button>

           <div class="mr-2 pointer flex-shrink-0">
               <p-avatar *ngIf="getAvatar(conv)" [image]="getAvatar(conv)!" size="normal" shape="circle" styleClass="w-2rem h-2rem"></p-avatar>
               <p-avatar *ngIf="!getAvatar(conv)" [label]="getInitials(conv.name)" size="normal" shape="circle" styleClass="w-2rem h-2rem font-bold text-base" [style]="{'background-color': '#CDD12A', 'color': '#000086'}"></p-avatar>
           </div>
           <div class="flex flex-column justify-content-center">
               <span class="font-bold text-base text-900" style="color: #111827 !important;">{{ conv.name }}</span>
               <ng-container *ngIf="getPresenceObj(presenceMap, conv) as presence">
                   <!-- Online state with inline dot -->
                   <div class="flex align-items-center gap-1 mt-1" *ngIf="presence.presenceStatus === 1">
                       <div class="border-circle" style="width: 8px; height: 8px; background-color: #16A34A;"></div>
                       <span class="text-xs font-medium" style="color: #16A34A;">Online now</span>
                   </div>
                   <!-- Offline state -->
                   <div class="flex align-items-center gap-1 mt-1" *ngIf="presence.presenceStatus === 0">
                       <div class="border-circle" style="width: 8px; height: 8px; background-color: #94a3b8;"></div>
                       <span class="text-xs font-medium" style="color: #64748b;" *ngIf="presence.lastSeen">Offline - Last seen {{ formatLastSeen(presence.lastSeen) }}</span>
                       <span class="text-xs font-medium" style="color: #64748b;" *ngIf="!presence.lastSeen">Offline</span>
                   </div>
               </ng-container>
           </div>
       </div>
        <!-- Actions -->
        <div class="flex gap-2 mr-2">
            <button pButton class="p-button-rounded p-button-text p-button-secondary flex align-items-center justify-content-center p-1 w-2rem h-2rem md:w-3rem md:h-3rem relative action-header-btn" 
                    (click)="togglePinnedDrawer()" pTooltip="Pinned Messages" tooltipPosition="bottom">
                <i class="pi pi-thumbtack text-xl text-600"></i>
                <span *ngIf="(pinnedMessages$ | async)?.length" class="absolute text-white text-xs font-bold border-circle flex align-items-center justify-content-center shadow-1" style="width: 1.25rem; height: 1.25rem; top: 0px; right: 0px; background-color: #000086; border: 0px solid white;">{{ (pinnedMessages$ | async)?.length }}</span>
            </button>
            <button pButton class="p-button-rounded p-button-text p-button-secondary flex align-items-center justify-content-center p-1 w-2rem h-2rem md:w-3rem md:h-3rem action-header-btn" (click)="openMediaDrawer()" pTooltip="Shared Media" tooltipPosition="bottom">
                <i class="pi pi-folder text-xl text-600"></i>
            </button>
           <!-- <button pButton icon="pi pi-phone" class="p-button-rounded p-button-text p-button-secondary"></button>
           <button pButton icon="pi pi-video" class="p-button-rounded p-button-text p-button-secondary"></button>
           <button pButton icon="pi pi-info-circle" class="p-button-rounded p-button-text p-button-secondary"></button> -->
       </div>
   </div>

   <!-- Messages -->
   <div #scrollContainer class="messages-area flex-1 overflow-y-auto custom-scrollbar flex flex-column p-3">
       
       <ng-container *ngFor="let msg of messages$ | async; let i = index; let isLast = last; trackBy: trackById">
           
           <!-- Date Separator -->
           <div *ngIf="showDateSeparator(msg, i, (messages$ | async) || [])" 
                class="flex justify-content-center w-full my-3 fadein animation-duration-300">
               <div class="bg-blue-50 border-round-xl px-3 py-1 shadow-1" style="font-size: 0.8rem;">
                   <span class="text-600 font-medium">{{ formatDateHeader(msg.sentAt) }}</span>
               </div>
           </div>

           <div class="message-row flex w-full mb-2 transition-all transition-duration-500" 
                 [id]="'message-' + msg.id"
                 [ngClass]="{'my-message': msg.isMyMessage, 'other-message': !msg.isMyMessage}">

                <!-- Avatar for other (only if first of group? simplified for now) -->
                 <p-avatar *ngIf="!msg.isMyMessage && getAvatar(conv)" [image]="getAvatar(conv)!" shape="circle" styleClass="w-2rem h-2rem mr-2 align-self-end mb-1"></p-avatar>
                 <p-avatar *ngIf="!msg.isMyMessage && !getAvatar(conv)" [label]="getInitials(conv.name)" shape="circle" styleClass="w-2rem h-2rem mr-2 align-self-end mb-1 font-bold text-sm" [style]="{'background-color': '#CDD12A', 'color': '#000086'}"></p-avatar>

            <div class="flex flex-column" [class.align-items-end]="msg.isMyMessage" [class.align-items-start]="!msg.isMyMessage" style="max-width: 70%; min-width: 120px;">
                
                <div class="message-bubble relative p-3 text-sm border-round-2xl" style="word-wrap: break-word; white-space: pre-wrap;" [ngClass]="{'bg-blue-500 text-white': msg.isMyMessage, 'bg-gray-100 text-900': !msg.isMyMessage}"
                     [ngClass]="{'border-primary border-1': msg.isPinned}">
                     
                    <!-- Pinned Indicator -->
                    <div *ngIf="msg.isPinned" class="flex align-items-center gap-1 mb-1 text-xs text-primary font-medium px-2 pt-1 border-bottom-1 border-200 pb-1 w-full relative">
                        <i class="pi pi-thumbtack" style="font-size: 0.70rem; transform: rotate(45deg);"></i> Pinned
                        <!-- Pin Action directly on bubble -->
                        <button *ngIf="currentUserId && msg.pinnedByUserId === currentUserId" pButton icon="pi pi-times" 
                            class="p-button-rounded p-button-text p-button-sm p-0 w-1rem h-1rem absolute ml-auto text-500 hover:text-red-500" 
                            style="right: 5px;" 
                            (click)="togglePin(msg)"
                            pTooltip="Unpin message" tooltipPosition="top"></button>
                    </div>

                    <!-- Pin Action for unpinned -->
                    <button *ngIf="!msg.isPinned" pButton icon="pi pi-thumbtack" 
                            class="pin-action-btn p-button-rounded p-button-text p-button-sm absolute transition-duration-200 text-500 hover:text-primary z-2 surface-0 shadow-1" 
                            style="top: -10px; right: -10px; padding: 0.25rem; width: 1.75rem; height: 1.75rem; transform: rotate(45deg);" 
                            (click)="togglePin(msg)"
                            pTooltip="Pin message" tooltipPosition="top"></button>
                     
                    <!-- Image Attachment -->
                    <div *ngIf="msg.chatMessageType === 1 && msg.attachmentUrl" 
                       (click)="openImageViewer(msg.attachmentUrl)" class="block mb-1 cursor-pointer">
                        <img [src]="msg.attachmentUrl" 
                             class="w-full border-round-md hover:shadow-3 transition-all transition-duration-200" 
                             alt="Image attachment" 
                             style="max-height: 300px; object-fit: cover; display: block;">
                    </div>
                         
                    <!-- File Attachment -->
                    <div *ngIf="msg.chatMessageType === 2 && msg.attachmentUrl" 
                       (click)="confirmDownload(msg.attachmentUrl, msg.fileName || getFileName(msg.attachmentUrl))" 
                       class="flex align-items-center gap-3 p-2 mb-1 border-round-lg cursor-pointer transition-colors transition-duration-150 no-underline"
                       style="background-color: rgba(0,0,0,0.5); width: 100%; border: 1px solid rgba(0,0,0,0.05);">
                        <div class="flex align-items-center justify-content-center border-round-md p-2"
                             [ngClass]="{'bg-white-alpha-50': msg.isMyMessage, 'bg-white': !msg.isMyMessage}">
                            <i class="pi pi-file text-2xl" [ngClass]="{'text-white': msg.isMyMessage, 'text-500': !msg.isMyMessage}"></i>
                        </div>
                        <div class="flex flex-column overflow-hidden" style="max-width: 200px;">
                            <span class="font-bold text-sm w-full text-overflow-ellipsis overflow-hidden white-space-nowrap line-height-2 text-white">{{ msg.fileName || getFileName(msg.attachmentUrl) }}</span>
                            <span class="text-xs mt-1 text-white-alpha-80">Click to open</span>
                        </div>
                    </div>

                    <!-- Text Content -->
                    <div *ngIf="msg.content" 
                         [innerHTML]="msg.content" 
                         class="text-content" 
                         [ngClass]="{'px-2': (msg.chatMessageType === 1 || msg.chatMessageType === 2) && msg.attachmentUrl, 'pt-2': (msg.chatMessageType === 1 || msg.chatMessageType === 2) && msg.attachmentUrl, 'pb-1': (msg.chatMessageType === 1 || msg.chatMessageType === 2) && msg.attachmentUrl, 'text-sm': (msg.chatMessageType === 1 || msg.chatMessageType === 2) && msg.attachmentUrl}" 
                         style="word-break: break-word;"></div>
                    
                    <!-- Timestamp -->
                    <div class="flex justify-content-end align-items-center gap-1 mt-1" 
                         [ngClass]="{'px-2': (msg.chatMessageType === 1 || msg.chatMessageType === 2) && msg.attachmentUrl, 'pb-1': (msg.chatMessageType === 1 || msg.chatMessageType === 2) && msg.attachmentUrl}">
                        <span class="text-xs" style="opacity: 0.7;">{{ msg.sentAt | date:'shortTime' }}</span>
                        <i *ngIf="msg.isMyMessage" class="pi text-xs" 
                           [ngClass]="{'pi-check': !msg.isRead, 'pi-check font-bold': msg.isRead}"
                           [style.color]="msg.isRead ? '#CDD12A' : 'rgba(255,255,255,0.7)'"></i>
                    </div>
                </div>
            </div>
            
            <!-- Avatar for me -->
            <p-avatar *ngIf="msg.isMyMessage && (currentUser$ | async)?.profileImageUrl" [image]="(currentUser$ | async)?.profileImageUrl!" shape="circle" styleClass="w-2.5rem h-2.5rem ml-3 align-self-end"></p-avatar>
            <p-avatar *ngIf="msg.isMyMessage && !(currentUser$ | async)?.profileImageUrl" [label]="getInitials((currentUser$ | async)?.firstName || 'M')" shape="circle" styleClass="w-2.5rem h-2.5rem ml-3 align-self-end font-bold text-base" [style]="{'background-color': '#000086', 'color': '#ffffff'}"></p-avatar>
       </div>
       </ng-container>

       <!-- Typing Indicator -->
       <!-- Typing Indicator -->
       <div *ngIf="typingText$ | async" class="flex align-items-center ml-3 mb-3 fadein animation-duration-200">
           <!-- Avatar -->
           <p-avatar *ngIf="getAvatar(conv)" [image]="getAvatar(conv)!" shape="circle" styleClass="w-2rem h-2rem mr-2"></p-avatar>
           <p-avatar *ngIf="!getAvatar(conv)" [label]="getInitials(conv.name)" shape="circle" styleClass="w-2rem h-2rem mr-2 font-bold text-sm" [style]="{'background-color': '#CDD12A', 'color': '#000086'}"></p-avatar>

           <!-- Bubble -->
           <div class="typing-bubble shadow-1 bg-white border-round-xl px-3 py-2 flex align-items-center gap-1"
                style="border-bottom-left-radius: 4px; width: fit-content;">
                <span class="dot"></span>
                <span class="dot"></span>
                <span class="dot"></span>
           </div>
       </div>
   </div>

    <!-- Input Area -->
    <div class="input-area z-2 bg-white">
         
         <!-- Input Wrapper -->
         <div class="input-wrapper relative bg-white" 
              [class.expanded]="showToolbar"
              style="min-height: 54px;">
             
             <!-- Mobile Toggle -->
             <button class="mobile-toggle action-btn md:hidden flex-shrink-0 mr-2" 
                     (click)="showMobileActions = !showMobileActions"
                     *ngIf="!showToolbar">
                 <i class="pi" [ngClass]="showMobileActions ? 'pi-times' : 'pi-plus'"></i>
             </button>

             <!-- Actions -->
             <div class="action-buttons align-items-center gap-1 transition-all transition-duration-300 mr-2" 
                  [ngClass]="{'hidden md:flex': !showMobileActions && !showToolbar, 'flex': showMobileActions || showToolbar}">
                 
                 <button class="action-btn" (click)="showToolbar = !showToolbar" [class.active]="showToolbar" pTooltip="Format" tooltipPosition="top">
                    <i class="pi pi-pencil"></i>
                 </button>

                 <div class="relative">
                    <button class="action-btn" [class.active]="showAttachMenu" (click)="toggleAttachMenu()" pTooltip="Attach" tooltipPosition="top">
                        <i class="pi pi-paperclip"></i>
                    </button>

                    <!-- Attachment Menu (Dropup) -->
                    <div *ngIf="showAttachMenu" class="absolute bottom-100 left-0 mb-2 bg-white shadow-4 border-round-xl overflow-hidden flex flex-column w-10rem z-5 attachment-menu">
                        <div class="p-3 hover:surface-100 cursor-pointer flex align-items-center gap-2 transition-colors transition-duration-150" (click)="imageInput.click()">
                            <i class="pi pi-image text-purple-500 text-xl"></i>
                            <span class="font-medium text-700">Image</span>
                        </div>
                        <div class="p-3 hover:surface-100 cursor-pointer flex align-items-center gap-2 transition-colors transition-duration-150" (click)="fileInput.click()">
                            <i class="pi pi-file text-blue-500 text-xl"></i>
                            <span class="font-medium text-700">File</span>
                        </div>
                    </div>

                    <!-- Hidden Inputs -->
                    <input #imageInput type="file" accept="image/*" class="hidden" (change)="handleFileSelection($event, 'image')">
                     <input #fileInput type="file" class="hidden" (change)="handleFileSelection($event, 'file')">
                 </div>
                 
                 <button class="action-btn" (click)="showEmoji = !showEmoji; showMobileActions = false">
                    <i class="pi pi-face-smile"></i>
                 </button>
             </div>

             <p-editor [(ngModel)]="newMessage" 
                        [style]="{'width': '100%'}"
                        [styleClass]="'chat-editor w-full' + (showToolbar ? ' toolbar-visible' : '')"
                        placeholder="Type a message..."
                        (onTextChange)="onTyping()"
                        (onInit)="handleEditorInit($event)">
                    <ng-template pTemplate="header">
                        <span class="ql-formats">
                            <button class="ql-bold" aria-label="Bold"></button>
                            <button class="ql-italic" aria-label="Italic"></button>
                            <button class="ql-strike" aria-label="Strike"></button>
                        </span>
                        <span class="ql-formats">
                            <button class="ql-list" value="ordered"></button>
                            <button class="ql-list" value="bullet"></button>
                        </span>
                        <span class="ql-formats">
                            <button class="ql-link" aria-label="Link"></button>
                        </span>
                    </ng-template>
             </p-editor>
             
             <div class="send-btn-wrapper flex-shrink-0 mr-1">
                 <button pButton label="Send" class="bg-send-custom border-none flex align-items-center justify-content-center shadow-1 hover:shadow-3 transition-all transition-duration-200" 
                         (click)="send()"></button>
             </div>
         </div>
        <!-- Preview Overlay (WhatsApp Style) -->
    <div *ngIf="selectedFile" class="pre-send-overlay absolute top-0 left-0 w-full h-full z-5 bg-black-alpha-90 flex flex-column fadein animation-duration-200">
        <!-- Header -->
        <div class="flex align-items-center justify-content-between p-3 text-white">
            <button pButton icon="pi pi-times" class="p-button-rounded p-button-text p-button-plain text-white" (click)="clearAttachment()"></button>
            <span class="font-bold text-lg">Preview</span>
            <div style="width: 2.5rem;"></div> <!-- Spacer -->
        </div>

        <!-- Content -->
        <div class="flex-1 flex align-items-center justify-content-center overflow-hidden p-4 relative">
             <img *ngIf="filePreviewUrl" [src]="filePreviewUrl" class="max-w-full max-h-full shadow-5 border-round-lg" style="object-fit: contain;">
             
             <div *ngIf="!filePreviewUrl" class="flex flex-column align-items-center justify-content-center text-white p-5 border-round-2xl surface-ground">
                 <i class="pi pi-file text-6xl mb-3 text-900"></i>
                 <span class="text-xl font-bold text-900 break-all text-center">{{ selectedFile.name }}</span>
                 <span class="text-700 mt-2">{{ (selectedFile.size / 1024).toFixed(1) }} KB</span>
             </div>
        </div>

        <!-- Caption Input -->
        <div class="p-3 bg-black-alpha-80 w-full flex align-items-end gap-2" style="padding-bottom: 2rem;">
             <div class="flex-1 bg-white border-round-3xl flex align-items-center px-3 py-2">
                 <input pInputText type="text" [(ngModel)]="newMessage" 
                        placeholder="Add a caption..." 
                        class="w-full border-none shadow-none bg-transparent text-900 focus:outline-none"
                        (keydown.enter)="send()">
             </div>
             <button pButton label="Send" class="bg-send-custom border-none flex align-items-center justify-content-center shadow-3" 
                     (click)="send()"></button>
        </div>
    </div>
</div>

   <!-- Full Screen Image Viewer -->
   <div *ngIf="viewingImage" class="viewer-overlay fixed top-0 left-0 w-full h-full z-4 bg-black-alpha-90 flex flex-column fadein animation-duration-200">
        <!-- Header -->
        <div class="flex justify-content-end p-3 text-white">
            <a [href]="viewingImage" target="_blank" download pButton icon="pi pi-download" class="p-button-rounded p-button-text text-white mr-3" pTooltip="Download" tooltipPosition="bottom"></a>
            <button pButton icon="pi pi-times" class="p-button-rounded p-button-text text-white" (click)="closeImageViewer()"></button>
        </div>
        <!-- Content -->
        <div class="flex-1 flex align-items-center justify-content-center p-4 cursor-pointer" (click)="closeImageViewer()">
            <img [src]="viewingImage" class="max-w-full max-h-full shadow-5 border-round-lg cursor-auto" style="object-fit: contain;" (click)="$event.stopPropagation()">
        </div>
   </div>

   <!-- Download Confirmation Dialog -->
   <p-dialog header="Confirm Download" [(visible)]="displayDownloadConfirm" [modal]="true" 
             [draggable]="false" [resizable]="false" 
             [style]="{width: '350px', maxWidth: '90vw'}"
             (onHide)="cancelDownload()">
       <div class="flex flex-column align-items-center justify-content-center pt-3 pb-4">
           <i class="pi pi-download text-5xl text-blue-500 mb-3"></i>
           <p class="m-0 text-center text-700">Are you sure you want to download</p>
           <p class="font-bold text-900 m-0 mt-1 text-center word-break break-all">{{ confirmDownloadTarget?.name }}?</p>
       </div>
       <ng-template pTemplate="footer">
           <div class="flex w-full justify-content-end gap-2">
               <button pButton label="Cancel" class="p-button-text p-button-secondary" (click)="cancelDownload()"></button>
               <button pButton label="Download" class="p-button-primary bg-send-custom border-none" (click)="executeDownload()"></button>
           </div>
       </ng-template>
   </p-dialog>

   <!-- Emoji Picker (Moved to Root) -->
   <div *ngIf="showEmoji" class="emoji-picker-container absolute z-5">
        <div class="fixed top-0 left-0 w-full h-full" (click)="showEmoji = false"></div>
        <div class="emoji-picker-content relative z-1 shadow-8 border-round-xl surface-card overflow-hidden flex flex-column" 
             style="height: 400px; width: 340px; max-width: 90vw;">
            <emoji-mart (emojiSelect)="addEmoji($event)" 
                        [isNative]="true" 
                        [showPreview]="false" 
                        [darkMode]="false"
                        [perLine]="7"
                        [showSingleCategory]="true"
                        class="h-full w-full"
                        [style]="{ width: '100%', height: '100%', border: 'none' }"></emoji-mart>
        </div>
   </div>
   <!-- Shared Media Drawer -->
   <div *ngIf="showMediaDrawer" class="absolute top-0 right-0 h-full bg-white shadow-4 flex flex-column z-3 slide-in-right" style="width: 450px; border-left: 1px solid #e5e7eb;">
       <div class="px-3 py-1 border-bottom-1 border-gray-200 flex align-items-center justify-content-between">
           <h3 class="m-0 text-lg text-900 font-bold">Shared Media</h3>
           <button pButton icon="pi pi-times" class="p-button-rounded p-button-text p-button-secondary" (click)="showMediaDrawer = false"></button>
       </div>
       
       <!-- Pill Tabs -->
       <div class="flex align-items-center gap-2 px-3 py-3 overflow-x-auto custom-scrollbar border-bottom-1 border-gray-200">
           <div class="flex-shrink-0 px-3 py-2 border-round-3xl font-medium text-sm flex align-items-center gap-2 cursor-pointer transition-colors"
                   [ngStyle]="mediaType === 'File' ? {'background-color': '#000086', 'border': '1px solid #000086'} : {'background-color': '#ffffff', 'border': '1px solid #d1d5db'}"
                   [ngClass]="{'text-white': mediaType === 'File', 'text-700 hover:surface-100': mediaType !== 'File'}"
                   (click)="loadMedia('File')">
               <i class="pi pi-file"></i> Documents
           </div>
           <div class="flex-shrink-0 px-3 py-2 border-round-3xl font-medium text-sm flex align-items-center gap-2 cursor-pointer transition-colors"
                   [ngStyle]="mediaType === 'Image' ? {'background-color': '#000086', 'border': '1px solid #000086'} : {'background-color': '#ffffff', 'border': '1px solid #d1d5db'}"
                   [ngClass]="{'text-white': mediaType === 'Image', 'text-700 hover:surface-100': mediaType !== 'Image'}"
                   (click)="loadMedia('Image')">
               <i class="pi pi-image"></i> Images
           </div>
           <div class="flex-shrink-0 px-3 py-2 border-round-3xl font-medium text-sm flex align-items-center gap-2 cursor-pointer transition-colors"
                   [ngStyle]="mediaType === 'Link' ? {'background-color': '#000086', 'border': '1px solid #000086'} : {'background-color': '#ffffff', 'border': '1px solid #d1d5db'}"
                   [ngClass]="{'text-white': mediaType === 'Link', 'text-700 hover:surface-100': mediaType !== 'Link'}"
                   (click)="loadMedia('Link')">
               <i class="pi pi-link"></i> Links
           </div>
           <div class="flex-shrink-0 px-3 py-2 border-round-3xl font-medium text-sm flex align-items-center gap-2 cursor-pointer transition-colors"
                   [ngStyle]="mediaType === 'All' ? {'background-color': '#000086', 'border': '1px solid #000086'} : {'background-color': '#ffffff', 'border': '1px solid #d1d5db'}"
                   [ngClass]="{'text-white': mediaType === 'All', 'text-700 hover:surface-100': mediaType !== 'All'}"
                   (click)="loadMedia('All')">
               <i class="pi pi-list"></i> All
           </div>
       </div>

       <!-- Content Area -->
       <div class="flex-1 overflow-y-auto custom-scrollbar relative" (scroll)="onMediaScroll($event)">
           <div *ngIf="isMediaLoading && mediaList.length === 0" class="p-3 text-center text-500 absolute top-50 left-50" style="transform: translate(-50%, -50%);">
               <i class="pi pi-spin pi-spinner text-3xl"></i>
           </div>

           <div *ngIf="!isMediaLoading && mediaList.length === 0" class="p-5 text-center text-500 flex flex-column align-items-center justify-content-center h-full">
               <i [class]="'pi text-5xl mb-3 text-300 ' + (mediaType === 'File' ? 'pi-file' : mediaType === 'Image' ? 'pi-image' : mediaType === 'Link' ? 'pi-link' : 'pi-folder-open')"></i>
               <span class="text-base">No {{mediaType === 'All' ? 'media' : mediaType.toLowerCase() + 's'}} shared yet.</span>
           </div>

           <div *ngIf="mediaList.length > 0 && mediaType !== 'Image'" class="flex flex-column p-2 gap-1">
               <div *ngFor="let media of mediaList" class="p-2 border-round hover:surface-100 cursor-pointer flex align-items-center gap-3 transition-colors" 
                    (click)="media.type === 1 ? openImageViewer(media.attachmentUrl) : (media.type === 4 ? null : confirmDownload(media.attachmentUrl, media.fileName || getFileName(media.attachmentUrl)))">
                   
                   <div class="border-round p-3 flex align-items-center justify-content-center" 
                        [ngClass]="{'bg-blue-50 text-blue-500': media.type === 2, 'bg-purple-50 text-purple-500': media.type === 4, 'bg-green-50 text-green-500': media.type === 1, 'surface-100 text-600': media.type !== 1 && media.type !== 2 && media.type !== 4}">
                       <i [class]="'pi text-xl ' + (media.type === 1 ? 'pi-image' : media.type === 4 ? 'pi-link' : 'pi-file')"></i>
                   </div>
                   
                   <div class="flex flex-column overflow-hidden flex-1">
                       <ng-container *ngIf="media.type === 4 || (mediaType === 'Link')">
                           <a [href]="media.attachmentUrl || media.metadata" target="_blank" class="font-medium text-blue-600 text-sm white-space-nowrap overflow-hidden text-overflow-ellipsis text-decoration-none hover:underline" (click)="$event.stopPropagation()">{{media.attachmentUrl || media.metadata || 'Open Link'}}</a>
                       </ng-container>
                       <ng-container *ngIf="media.type !== 4 && (mediaType !== 'Link')">
                           <span class="font-medium text-800 text-sm white-space-nowrap overflow-hidden text-overflow-ellipsis">{{media.fileName || getFileName(media.attachmentUrl)}}</span>
                       </ng-container>
                       
                       <span class="text-xs text-500">{{media.senderName}} • {{media.sentAt | date:'shortTime'}}</span>
                   </div>
               </div>
           </div>

           <div *ngIf="mediaList.length > 0 && mediaType === 'Image'" class="flex flex-wrap p-2 w-full">
               <div *ngFor="let media of mediaList" class="p-1" style="width: 33.3333%;">
                   <div class="border-round overflow-hidden cursor-pointer hover:shadow-2 transition-all bg-gray-100 border-1 border-200" style="aspect-ratio: 1;" (click)="openImageViewer(media.attachmentUrl)">
                       <img [src]="media.thumbnailUrl || media.attachmentUrl" class="w-full h-full block relative z-1" style="object-fit: cover;">
                   </div>
               </div>
           </div>
           
           <!-- Load More Indicator -->
           <div *ngIf="isLoadingMoreMedia" class="p-3 w-full text-center text-500 my-2">
               <i class="pi pi-spin pi-spinner text-xl"></i><span class="ml-2 text-sm">Loading more...</span>
           </div>
       </div>
   </div>

   <!-- Pinned Messages Drawer -->
   <div *ngIf="showPinnedDrawer" class="absolute top-0 right-0 h-full bg-white shadow-4 flex flex-column z-3 slide-in-right" style="width: 450px; border-left: 1px solid #e5e7eb;">
       <div class="px-3 py-1 border-bottom-1 border-gray-200 flex align-items-center justify-content-between">
           <div class="flex align-items-center gap-2">
               <div class="border-round p-2 flex align-items-center justify-content-center" style="background-color: rgba(0, 0, 134, 0.08);">
                   <i class="pi pi-thumbtack text-xl" style="color: #000086; transform: rotate(45deg);"></i>
               </div>
               <h3 class="m-0 text-lg text-900 font-bold">Pinned Messages</h3>
           </div>
           <button pButton icon="pi pi-times" class="p-button-rounded p-button-text p-button-secondary" (click)="showPinnedDrawer = false"></button>
       </div>
       
       <div class="flex-1 overflow-y-auto custom-scrollbar relative p-3 surface-ground">
           <ng-container *ngIf="(pinnedMessages$ | async) as pinnedList">
               <div *ngIf="pinnedList.length === 0" class="flex flex-column align-items-center justify-content-center h-full text-500">
                   <div class="surface-0 p-4 border-round-2xl shadow-1 flex flex-column align-items-center">
                       <i class="pi pi-thumbtack text-6xl mb-3 text-300" style="transform: rotate(45deg);"></i>
                       <span class="text-lg font-medium text-900 mb-2">No pinned messages</span>
                       <span class="text-sm text-center text-600">Messages you pin will appear here for easy access.</span>
                   </div>
               </div>
               
               <div *ngIf="pinnedList.length > 0" class="flex flex-column gap-3">
                   <div *ngFor="let msg of pinnedList" 
                         (click)="scrollToMessage(msg.id)" 
                         class="p-3 border-round-xl surface-0 shadow-1 hover:shadow-2 transition-all cursor-pointer border-l-4" style="border-left-color: #000086 !important;">
                       <div class="flex justify-content-between align-items-start mb-2">
                           <div class="flex align-items-center gap-2">
                               <p-avatar [image]="msg.senderProfilePicture || 'assets/images/default-profile.png'" shape="circle" styleClass="w-1.5rem h-1.5rem"></p-avatar>
                               <span class="font-bold text-sm text-900">{{ msg.senderName }}</span>
                           </div>
                           <button *ngIf="currentUserId && msg.pinnedByUserId === currentUserId" pButton icon="pi pi-times" class="p-button-rounded p-button-text p-button-secondary w-1.5rem h-1.5rem p-0" (click)="togglePin(msg); $event.stopPropagation()" pTooltip="Unpin" tooltipPosition="left"></button>
                       </div>
                       
                       <div *ngIf="msg.content" class="text-sm text-700 line-height-3 mb-2" [innerHTML]="msg.content" style="word-break: break-word; display: -webkit-box; -webkit-line-clamp: 3; line-clamp: 3; -webkit-box-orient: vertical; overflow: hidden;"></div>
                       
                       <div *ngIf="msg.attachmentUrl" class="text-sm flex align-items-center gap-1 mb-2 border-round p-2 w-max text-xs font-medium" style="background-color: rgba(0, 0, 134, 0.08); color: #000086;">
                           <i [class]="msg.chatMessageType === 1 ? 'pi pi-image' : 'pi pi-file'"></i>
                           <span>{{ msg.fileName || 'Attachment' }}</span>
                       </div>
                       
                       <div class="flex justify-content-between align-items-center text-xs text-500 mt-2 border-top-1 border-200 pt-2">
                           <span>{{ msg.sentAt | date:'mediumDate' }} • {{ msg.sentAt | date:'shortTime' }}</span>
                           <span *ngIf="msg.pinnedByName" class="font-medium px-2 py-1 border-round" style="background-color: rgba(0, 0, 134, 0.08); color: #000086;">Pinned by {{ msg.pinnedByName }}</span>
                       </div>
                   </div>
               </div>
           </ng-container>
       </div>
   </div>

   </ng-container>
</div>

<ng-template #emptyState>
    <div class="h-full flex flex-column align-items-center justify-content-center bg-white text-500">
        <i class="pi pi-comments text-6xl mb-3 text-300"></i>
        <span class="text-xl font-medium text-700">Select a conversation to start chatting</span>
    </div>
</ng-template>
